import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  height?: number;
}
export const Hr = styled.hr<IProps>`
  height: ${({ height }) => (height ? rem(height) : rem(1))};
  width: 100%;
  border: 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.color['gray-200']}`};
`;
